import React from 'react';
import PropTypes from 'prop-types';

import { confirmPartner } from '../../api';

import SelectLinkDistributionModal from '../SelectLinkDistributionModal/SelectLinkDistributionModal';

const PartnerApprovalModal = ({ isOpen, userId, onRequestClose, onSuccess }) => {
  const handleConfirm = async salesCodes => {
    await confirmPartner(userId, salesCodes);
    onSuccess();
    // Keep the existing close behavior: the selector also closes itself after
    // a successful confirmation.
    onRequestClose();
  };

  return (
    <SelectLinkDistributionModal
      isOpen={isOpen}
      userId={userId}
      onRequestClose={onRequestClose}
      onConfirm={handleConfirm}
    />
  );
};

PartnerApprovalModal.propTypes = {
  isOpen: PropTypes.bool,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

PartnerApprovalModal.defaultProps = {
  isOpen: false,
};

export default PartnerApprovalModal;
